import {Component, Inject, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import {BlockService} from '../../service/BlockService';
import {SearchPipe} from '../../pipe/search.pipe';

@Component({
  selector: 'app-user-guide',
  templateUrl: './user-guide.component.html',
  styleUrls: ['./user-guide.component.css']
})
export class ModalUserGuideComponent implements OnInit {

  searchDelegate = '';
  dataFiltred = [] = [];
  userGuides = [
    {
      name: 'All about MyShift',
      nameSearch: 'All about MyShift',
      filename: 'all_about_myshift.pdf',
      selectMsg: 'Cliquez pour sélectionner',
      isSelected: false,
      label:"ALL_ABOUT"
    },
    {
      name: 'Injections Self service',
      nameSearch: 'Injections Self service',
      filename: 'user_guide_evolution_injections_myshift_v2.pdf',
      selectMsg: 'Cliquez pour sélectionner',
      isSelected: false,
      label:"INJECTION"
    }, {
      name: 'Réouverture',
      nameSearch: 'reouverture',
      filename: 'user_guide_evolution_reouvertures.pdf',
      selectMsg: 'Cliquez pour sélectionner',
      isSelected: false,
      label:"REOPEN"
    }, {
      name: 'Délégation',
      nameSearch: 'delegation',
      filename: 'user_guide_evolution_delegation_myshift.pdf',
      selectMsg: 'Cliquez pour sélectionner',
      isSelected: false,
      label:"DELEGATION"
    }, {
      name: 'Déverrouillage',
      nameSearch: 'deverrouillage',
      filename: 'user_guide_evolution_deverrouillage_myshift.pdf',
      selectMsg: 'Cliquez pour sélectionner',
      isSelected: false,
      label:"UNLOCK"
  }
  ];

  constructor(public dialog: MatDialog,
              private translate: TranslateService,
              private blockservice: BlockService,
              private searchPipe: SearchPipe,
              @Inject(MAT_DIALOG_DATA) public injectData) {
  }


  ngOnInit() {
    this.dataFiltred = this.userGuides;
  }

  search(search: any) {
    if (!search || search == '') {
       this.userGuides = this.dataFiltred;
    } else {
      this.userGuides.forEach(u=> u.isSelected = false);
      this.userGuides = this.searchPipe.transform(this.dataFiltred, search, ['name','nameSearch']);
    }
  }
  total() {
    return this.userGuides.filter(u => u.isSelected).length;
  }

  download(isAll) {
    if (isAll){
      this.userGuides.forEach(userG=> {
        this.blockservice.saveFile(userG.filename);
      })
    }else {
      this.userGuides.filter(u=> u.isSelected).
      forEach(userG=> {
        this.blockservice.saveFile(userG.filename);
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/layout/user-guide/user-guide.component.ts